declare namespace $ {

	export class $mol_view_tree2_to_js_test_ex_simple_empty_class_foo extends $mol_object {
	}
	
}

//# sourceMappingURL=simple_empty_class.view.tree.d.ts.map